import * as Sentry from "@sentry/react";

const SENSITIVE_FIELDS = /password|confirm_password|token|secret|card|cvv|ssn|credit/i;

function scrubBreadcrumbs(event: Sentry.ErrorEvent): Sentry.ErrorEvent {
  event.breadcrumbs = event.breadcrumbs?.map((crumb) => {
    if (crumb.data && typeof crumb.data === "object") {
      const scrubbed: Record<string, any> = {};
      for (const [key, val] of Object.entries(crumb.data)) {
        scrubbed[key] = SENSITIVE_FIELDS.test(key) ? "[Filtered]" : val;
      }
      return { ...crumb, data: scrubbed };
    }
    return crumb;
  });
  return event;
}

export function initSentry(): void {
  if (!import.meta.env.PROD) return;
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
    beforeSend(event) {
      return scrubBreadcrumbs(event);
    },
  });
}

export { Sentry };
